import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { annoncesAPI, commandesAPI, getUser, logout } from '../api';
import '../App.css';

const statutCmd = {
  confirme:   { label: 'Nouvelle', bg: 'rgba(245,98,10,.12)', color: '#F5620A' },
  accepte:    { label: 'Accepte', bg: 'rgba(245,158,11,.12)', color: '#F59E0B' },
  collecte:   { label: 'Collecte en cours', bg: 'rgba(245,158,11,.12)', color: '#F59E0B' },
  transit:    { label: 'En livraison', bg: 'rgba(99,102,241,.12)', color: '#818CF8' },
  livre:      { label: '✓ Livre', bg: 'rgba(34,197,94,.12)', color: '#22C55E' },
  annule:     { label: 'Annule', bg: 'rgba(239,68,68,.12)', color: '#EF4444' },
};

const statutAnnonce = {
  active:   { label: '● Actif', bg: 'rgba(34,197,94,.12)', color: '#22C55E' },
  brouillon:{ label: 'Brouillon', bg: 'rgba(255,255,255,.06)', color: '#888' },
  vendue:   { label: 'Vendu', bg: 'rgba(91,33,182,.12)', color: '#A78BFA' },
  suspendue:{ label: 'Suspendu', bg: 'rgba(239,68,68,.12)', color: '#EF4444' },
};

function DashboardVendeur() {
  const navigate = useNavigate();
  const user = getUser();
  const [activeSection, setActiveSection] = useState('dashboard');
  const [commandes, setCommandes] = useState([]);
  const [annonces, setAnnonces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showRetraitModal, setShowRetraitModal] = useState(false);
  const [selectedMM, setSelectedMM] = useState('Wave');
  const [retraitPhone, setRetraitPhone] = useState('');
  const [retraitDone, setRetraitDone] = useState(false);
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    if (!user) { navigate('/connexion'); return; }
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [cmdRes, annRes] = await Promise.all([
        commandesAPI.commandesVendeur(),
        annoncesAPI.mesAnnonces(),
      ]);
      setCommandes(cmdRes.data || []);
      setAnnonces(annRes.data || []);
    } catch (err) {
      console.error('Erreur chargement:', err);
    } finally {
      setLoading(false);
    }
  };

  const updateStatut = async (cmdId, statut) => {
    try {
      await commandesAPI.updateStatut(cmdId, statut);
      showToast('Statut mis a jour ✓', 'ok');
      fetchData();
    } catch (err) {
      showToast('Erreur mise a jour', 'err');
    }
  };

  const showToast = (msg, type = '') => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, msg, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 3000);
  };

  const initials = user ? (user.prenom?.[0] || '') + (user.nom?.[0] || '') : 'V';
  const newCommandes = commandes.filter(c => c.statut === 'confirme').length;
  const revenuTotal = commandes.filter(c => c.statut === 'livre').reduce((sum, c) => sum + parseFloat(c.total || 0), 0);
  const revenuNet = revenuTotal * 0.95;

  const navItems = [
    { key: 'dashboard', icon: '📊', label: 'Tableau de bord' },
    { key: 'commandes', icon: '🔔', label: 'Commandes recues', badge: newCommandes > 0 ? String(newCommandes) : null },
    { key: 'annonces', icon: '📋', label: 'Mes annonces' },
    { key: 'revenus', icon: '💰', label: 'Revenus' },
  ];

  return (
    <div className="app" style={{ display: 'grid', gridTemplateColumns: '230px 1fr', minHeight: '100vh' }}>

      {/* SIDEBAR */}
      <div style={{ background: '#141414', borderRight: '1px solid #2A2A2A', display: 'flex', flexDirection: 'column', position: 'sticky', top: 0, height: '100vh', overflowY: 'auto' }}>
        <div style={{ padding: '20px 20px 16px', borderBottom: '1px solid #2A2A2A' }}>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '24px', letterSpacing: '2px', color: '#fff', lineHeight: 1 }}>Tek<span style={{ color: '#F5620A' }}>Teck</span></div>
            <div style={{ fontSize: '9px', fontWeight: '700', color: '#F5620A', letterSpacing: '.5px' }}>rak tak!</div>
          </Link>
        </div>
        <div style={{ padding: '14px 18px', borderBottom: '1px solid #2A2A2A', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ width: '38px', height: '38px', borderRadius: '50%', background: '#F5620A', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '800', fontSize: '13px', color: '#fff', flexShrink: 0 }}>{initials}</div>
          <div>
            <div style={{ fontSize: '13px', fontWeight: '700', color: '#fff' }}>{user?.prenom} {user?.nom}</div>
            <div style={{ fontSize: '11px', color: '#888' }}>Vendeur · {user?.ville}</div>
          </div>
        </div>
        <div style={{ padding: '10px 12px', flex: 1 }}>
          {navItems.map((item) => (
            <div key={item.key} onClick={() => setActiveSection(item.key)}
              style={{ display: 'flex', alignItems: 'center', gap: '9px', padding: '9px 10px', borderRadius: '8px', cursor: 'pointer', marginBottom: '2px', background: activeSection === item.key ? 'rgba(245,98,10,.12)' : 'transparent', border: activeSection === item.key ? '1px solid rgba(245,98,10,.2)' : '1px solid transparent' }}>
              <span style={{ fontSize: '14px', width: '18px', textAlign: 'center' }}>{item.icon}</span>
              <span style={{ fontSize: '12px', fontWeight: '600', color: activeSection === item.key ? '#F5620A' : '#888', flex: 1 }}>{item.label}</span>
              {item.badge && <span style={{ background: '#F5620A', color: '#fff', fontSize: '10px', fontWeight: '800', padding: '2px 7px', borderRadius: '8px' }}>{item.badge}</span>}
            </div>
          ))}
        </div>
        <div style={{ padding: '12px 18px', borderTop: '1px solid #2A2A2A' }}>
          <Link to="/deposer-annonce">
            <button className="btn-orange" style={{ width: '100%', marginBottom: '8px', fontSize: '12px' }}>+ Nouvelle annonce</button>
          </Link>
          <button onClick={logout} style={{ width: '100%', padding: '8px', background: 'transparent', border: '1.5px solid #333', borderRadius: '8px', fontSize: '12px', fontWeight: '700', color: '#888', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
            Deconnexion
          </button>
        </div>
      </div>

      {/* MAIN */}
      <div style={{ overflow: 'auto' }}>
        {/* TOPBAR */}
        <div style={{ background: '#141414', borderBottom: '1px solid #2A2A2A', padding: '0 28px', height: '58px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 50 }}>
          <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '20px', letterSpacing: '1px', color: '#fff' }}>
            {activeSection === 'dashboard' ? 'TABLEAU DE BORD' : activeSection === 'commandes' ? 'COMMANDES RECUES' : activeSection === 'annonces' ? 'MES ANNONCES' : 'REVENUS'}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {newCommandes > 0 && (
              <div style={{ background: 'rgba(245,98,10,.12)', border: '1px solid rgba(245,98,10,.3)', borderRadius: '20px', padding: '4px 12px', fontSize: '12px', fontWeight: '700', color: '#F5620A' }}>
                🔔 {newCommandes} nouvelle{newCommandes > 1 ? 's' : ''} commande{newCommandes > 1 ? 's' : ''}
              </div>
            )}
          </div>
        </div>

        <div style={{ padding: '22px 28px 60px' }}>

          {loading && (
            <div style={{ textAlign: 'center', padding: '60px 20px' }}>
              <div style={{ fontSize: '32px', marginBottom: '16px' }}>⏳</div>
              <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '20px', color: '#fff' }}>CHARGEMENT...</div>
            </div>
          )}

          {/* ===== DASHBOARD ===== */}
          {!loading && activeSection === 'dashboard' && (
            <>
              {/* KPIS */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '12px', marginBottom: '22px' }}>
                {[
                  { label: 'REVENUS NETS', val: revenuNet.toLocaleString('fr-FR'), sub: 'FCFA (commission 5% deduite)', subColor: '#22C55E' },
                  { label: 'COMMANDES RECUES', val: String(commandes.length), sub: `${newCommandes} nouvelles`, subColor: newCommandes > 0 ? '#F5620A' : '#888' },
                  { label: 'ANNONCES ACTIVES', val: String(annonces.filter(a => a.statut === 'active').length), sub: `${annonces.length} total`, subColor: '#888' },
                  { label: 'SOLDE A RETIRER', val: revenuNet.toLocaleString('fr-FR'), sub: 'FCFA disponibles', subColor: '#22C55E', action: () => setShowRetraitModal(true) },
                ].map((k, i) => (
                  <div key={i} style={{ background: '#1C1C1C', border: '1px solid #333', borderRadius: '12px', padding: '16px 18px' }}>
                    <div style={{ fontSize: '10px', fontWeight: '700', color: '#888', letterSpacing: '.4px', marginBottom: '5px' }}>{k.label}</div>
                    <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '20px', letterSpacing: '1px', color: i === 3 ? '#22C55E' : '#fff', marginBottom: '2px' }}>{k.val}</div>
                    <div onClick={k.action} style={{ fontSize: '11px', fontWeight: '700', color: k.subColor, cursor: k.action ? 'pointer' : 'default' }}>{k.sub}</div>
                  </div>
                ))}
              </div>

              {/* DERNIERES COMMANDES */}
              <div style={{ background: '#1C1C1C', border: '1px solid #333', borderRadius: '14px', padding: '18px 22px', marginBottom: '18px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
                  <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '16px', letterSpacing: '1px', color: '#fff' }}>📦 DERNIERES COMMANDES</div>
                  <span onClick={() => setActiveSection('commandes')} style={{ fontSize: '12px', color: '#F5620A', fontWeight: '700', cursor: 'pointer' }}>Voir tout →</span>
                </div>
                {commandes.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '20px', color: '#888', fontSize: '13px' }}>Aucune commande reçue pour l'instant</div>
                ) : (
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>{['Piece','Acheteur','Statut','Total'].map(h => (
                        <th key={h} style={{ textAlign: 'left', padding: '7px 10px', fontSize: '10px', fontWeight: '700', color: '#888', letterSpacing: '.4px', borderBottom: '1px solid #2A2A2A' }}>{h}</th>
                      ))}</tr>
                    </thead>
                    <tbody>
                      {commandes.slice(0, 5).map((cmd, i) => {
                        const sc = statutCmd[cmd.statut] || statutCmd.confirme;
                        return (
                          <tr key={cmd.id} style={{ borderBottom: i < 4 ? '1px solid #2A2A2A' : 'none' }}>
                            <td style={{ padding: '10px 10px' }}>
                              <div style={{ fontSize: '12px', fontWeight: '700', color: '#fff' }}>{cmd.nom_piece}</div>
                              <div style={{ fontSize: '10px', color: '#888' }}>{cmd.reference}</div>
                            </td>
                            <td style={{ padding: '10px 10px', fontSize: '12px', color: '#888' }}>{cmd.prenom} {cmd.nom}</td>
                            <td style={{ padding: '10px 10px' }}><span style={{ padding: '3px 9px', borderRadius: '20px', fontSize: '10px', fontWeight: '800', background: sc.bg, color: sc.color }}>{sc.label}</span></td>
                            <td style={{ padding: '10px 10px', fontFamily: 'Bebas Neue, sans-serif', fontSize: '15px', color: '#F5620A' }}>{parseInt(cmd.total).toLocaleString('fr-FR')} F</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </div>

              {/* DERNIÈRES ANNONCES */}
              <div style={{ background: '#1C1C1C', border: '1px solid #333', borderRadius: '14px', padding: '18px 22px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
                  <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '16px', letterSpacing: '1px', color: '#fff' }}>📋 MES ANNONCES</div>
                  <span onClick={() => setActiveSection('annonces')} style={{ fontSize: '12px', color: '#F5620A', fontWeight: '700', cursor: 'pointer' }}>Voir tout →</span>
                </div>
                {annonces.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '20px', color: '#888', fontSize: '13px' }}>
                    Aucune annonce publiée — <Link to="/deposer-annonce" style={{ color: '#F5620A', fontWeight: '700' }}>Deposer une annonce</Link>
                  </div>
                ) : (
                  annonces.slice(0, 4).map(a => {
                    const sa = statutAnnonce[a.statut] || statutAnnonce.active;
                    return (
                      <div key={a.id} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 0', borderBottom: '1px solid #2A2A2A' }}>
                        <div style={{ width: '40px', height: '40px', background: '#141414', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', flexShrink: 0 }}>🔧</div>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: '12px', fontWeight: '700', color: '#fff' }}>{a.nom_piece}</div>
                          <div style={{ fontSize: '10px', color: '#888' }}>{a.marque_vehicule} · {a.categorie} · {a.vues || 0} vues</div>
                        </div>
                        <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '14px', color: '#F5620A' }}>{parseInt(a.prix).toLocaleString('fr-FR')} F</div>
                        <span style={{ padding: '3px 9px', borderRadius: '20px', fontSize: '10px', fontWeight: '800', background: sa.bg, color: sa.color }}>{sa.label}</span>
                      </div>
                    );
                  })
                )}
              </div>
            </>
          )}

          {/* ===== COMMANDES ===== */}
          {!loading && activeSection === 'commandes' && (
            <div>
              {commandes.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '60px 20px', color: '#888' }}>
                  <div style={{ fontSize: '48px', marginBottom: '16px' }}>📦</div>
                  <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '24px', color: '#fff', marginBottom: '8px' }}>AUCUNE COMMANDE</div>
                  <div>Vous n'avez pas encore recu de commandes</div>
                </div>
              ) : (
                commandes.map(cmd => {
                  const sc = statutCmd[cmd.statut] || statutCmd.confirme;
                  return (
                    <div key={cmd.id} style={{ background: '#1C1C1C', border: '1px solid #333', borderRadius: '14px', padding: '16px 20px', marginBottom: '12px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' }}>
                        <div>
                          <div style={{ fontSize: '13px', fontWeight: '700', color: '#fff', marginBottom: '3px' }}>{cmd.nom_piece}</div>
                          <div style={{ fontSize: '11px', color: '#888' }}>{cmd.reference} · Acheteur : <span style={{ color: '#fff', fontWeight: '600' }}>{cmd.prenom} {cmd.nom}</span></div>
                          <div style={{ fontSize: '11px', color: '#888', marginTop: '2px' }}>{new Date(cmd.created_at).toLocaleDateString('fr-FR')} · {cmd.delai} · {cmd.mobile_money}</div>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                          <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '20px', color: '#F5620A' }}>{parseInt(cmd.total).toLocaleString('fr-FR')} F</div>
                          <span style={{ padding: '3px 10px', borderRadius: '20px', fontSize: '10px', fontWeight: '800', background: sc.bg, color: sc.color }}>{sc.label}</span>
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '7px', flexWrap: 'wrap' }}>
                        {cmd.statut === 'confirme' && (
                          <>
                            <button onClick={() => updateStatut(cmd.id, 'accepte')} style={{ padding: '7px 14px', border: 'none', background: '#22C55E', borderRadius: '7px', fontSize: '12px', fontWeight: '700', color: '#fff', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>✓ Accepter</button>
                            <button onClick={() => updateStatut(cmd.id, 'annule')} style={{ padding: '7px 14px', border: '1.5px solid #EF4444', background: 'transparent', borderRadius: '7px', fontSize: '12px', fontWeight: '700', color: '#EF4444', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>✗ Refuser</button>
                          </>
                        )}
                        {cmd.statut === 'accepte' && (
                          <button onClick={() => updateStatut(cmd.id, 'collecte')} style={{ padding: '7px 14px', border: 'none', background: '#F59E0B', borderRadius: '7px', fontSize: '12px', fontWeight: '700', color: '#fff', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>📦 Marquer collecte</button>
                        )}
                        {cmd.statut === 'collecte' && (
                          <button onClick={() => updateStatut(cmd.id, 'transit')} style={{ padding: '7px 14px', border: 'none', background: '#6366F1', borderRadius: '7px', fontSize: '12px', fontWeight: '700', color: '#fff', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>🛵 En livraison</button>
                        )}
                        {cmd.statut === 'transit' && (
                          <button onClick={() => updateStatut(cmd.id, 'livre')} style={{ padding: '7px 14px', border: 'none', background: '#22C55E', borderRadius: '7px', fontSize: '12px', fontWeight: '700', color: '#fff', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>✓ Marquer livre</button>
                        )}
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          )}

          {/* ===== ANNONCES ===== */}
          {!loading && activeSection === 'annonces' && (
            <div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '14px' }}>
                <Link to="/deposer-annonce"><button className="btn-orange">+ Nouvelle annonce</button></Link>
              </div>
              {annonces.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '60px 20px', color: '#888' }}>
                  <div style={{ fontSize: '48px', marginBottom: '16px' }}>📋</div>
                  <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '24px', color: '#fff', marginBottom: '8px' }}>AUCUNE ANNONCE</div>
                  <Link to="/deposer-annonce"><button className="btn-orange">Deposer ma premiere annonce</button></Link>
                </div>
              ) : (
                annonces.map(a => {
                  const sa = statutAnnonce[a.statut] || statutAnnonce.active;
                  return (
                    <div key={a.id} style={{ background: '#1C1C1C', border: '1px solid #333', borderRadius: '12px', padding: '14px 18px', marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '14px' }}>
                      <div style={{ width: '48px', height: '48px', background: '#141414', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px', flexShrink: 0 }}>🔧</div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: '13px', fontWeight: '700', color: '#fff', marginBottom: '2px' }}>{a.nom_piece}</div>
                        <div style={{ fontSize: '11px', color: '#888' }}>{a.type_vehicule} · {a.marque_vehicule} · {a.categorie} · {a.vues || 0} vues</div>
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '16px', color: '#F5620A', marginBottom: '3px' }}>{parseInt(a.prix).toLocaleString('fr-FR')} F</div>
                        <span style={{ padding: '3px 9px', borderRadius: '20px', fontSize: '10px', fontWeight: '800', background: sa.bg, color: sa.color }}>{sa.label}</span>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          )}

          {/* ===== REVENUS ===== */}
          {!loading && activeSection === 'revenus' && (
            <div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '12px', marginBottom: '22px' }}>
                {[
                  { label: 'REVENUS BRUTS', val: revenuTotal.toLocaleString('fr-FR'), sub: 'FCFA total des ventes', subColor: '#888' },
                  { label: 'COMMISSION TEKTECK (5%)', val: (revenuTotal * 0.05).toLocaleString('fr-FR'), sub: 'FCFA prelevés', subColor: '#EF4444' },
                  { label: 'REVENUS NETS', val: revenuNet.toLocaleString('fr-FR'), sub: 'FCFA a percevoir', subColor: '#22C55E' },
                ].map((k, i) => (
                  <div key={i} style={{ background: '#1C1C1C', border: '1px solid #333', borderRadius: '12px', padding: '16px 18px' }}>
                    <div style={{ fontSize: '10px', fontWeight: '700', color: '#888', letterSpacing: '.4px', marginBottom: '5px' }}>{k.label}</div>
                    <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '22px', letterSpacing: '1px', color: '#fff', marginBottom: '2px' }}>{k.val}</div>
                    <div style={{ fontSize: '11px', fontWeight: '700', color: k.subColor }}>{k.sub}</div>
                  </div>
                ))}
              </div>
              <div style={{ background: '#1C1C1C', border: '1px solid #333', borderRadius: '14px', padding: '20px 22px', textAlign: 'center' }}>
                <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '20px', color: '#fff', marginBottom: '8px' }}>SOLDE DISPONIBLE</div>
                <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '40px', color: '#22C55E', marginBottom: '14px' }}>{retraitDone ? '0' : revenuNet.toLocaleString('fr-FR')} FCFA</div>
                <button onClick={() => setShowRetraitModal(true)} style={{ padding: '12px 28px', background: '#F5620A', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: '800', color: '#fff', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                  📤 Retirer mes fonds
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* MODAL RETRAIT */}
      {showRetraitModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.75)', zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={e => e.target === e.currentTarget && setShowRetraitModal(false)}>
          <div style={{ background: '#1C1C1C', border: '1px solid #333', borderRadius: '16px', padding: '28px 30px', maxWidth: '420px', width: '92%' }}>
            <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '22px', letterSpacing: '1px', color: '#fff', marginBottom: '4px' }}>RETIRER MES FONDS</div>
            <div style={{ fontSize: '12px', color: '#888', marginBottom: '18px' }}>Virement vers votre Mobile Money</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '14px' }}>
              {['Wave','Orange Money','Free Money','Expresso'].map(mm => (
                <div key={mm} onClick={() => setSelectedMM(mm)} style={{ padding: '11px', border: `1.5px solid ${selectedMM === mm ? '#F5620A' : '#333'}`, borderRadius: '9px', cursor: 'pointer', textAlign: 'center', background: selectedMM === mm ? 'rgba(245,98,10,.1)' : '#141414' }}>
                  <div style={{ fontSize: '11px', fontWeight: '800', color: selectedMM === mm ? '#F5620A' : '#888' }}>📱 {mm}</div>
                </div>
              ))}
            </div>
            <div style={{ marginBottom: '14px' }}>
              <label style={{ fontSize: '11px', fontWeight: '700', color: '#888', display: 'block', marginBottom: '6px' }}>NUMERO MOBILE MONEY</label>
              <div style={{ display: 'flex', gap: '8px' }}>
                <div style={{ padding: '10px 12px', background: '#141414', border: '1.5px solid #333', borderRadius: '9px', fontSize: '14px', fontWeight: '700', color: '#fff' }}>🇸🇳 +221</div>
                <input type="tel" value={retraitPhone} onChange={e => setRetraitPhone(e.target.value)} placeholder="7X XXX XX XX" maxLength="9" style={{ flex: 1, padding: '10px 14px', background: '#141414', border: '1.5px solid #333', borderRadius: '9px', fontSize: '14px', fontFamily: 'Plus Jakarta Sans, sans-serif', color: '#fff', outline: 'none' }} />
              </div>
            </div>
            <div style={{ background: 'rgba(34,197,94,.08)', border: '1px solid rgba(34,197,94,.2)', borderRadius: '9px', padding: '10px 14px', fontSize: '12px', color: '#22C55E', fontWeight: '600', marginBottom: '16px' }}>
              🛡️ <strong>{revenuNet.toLocaleString('fr-FR')} FCFA</strong> seront vires sous <strong>24h</strong>. Frais : gratuit.
            </div>
            <button onClick={() => { if (retraitPhone.length < 9) return; setShowRetraitModal(false); setRetraitDone(true); showToast('Virement initie ! 24h ouvrées ✓', 'ok'); }} style={{ width: '100%', padding: '13px', background: '#F5620A', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: '800', color: '#fff', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif', marginBottom: '8px' }}>
              📤 Confirmer le virement
            </button>
            <button onClick={() => setShowRetraitModal(false)} style={{ width: '100%', padding: '10px', background: 'transparent', border: '1.5px solid #333', borderRadius: '10px', fontSize: '13px', fontWeight: '700', color: '#888', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>Annuler</button>
          </div>
        </div>
      )}

      {/* TOASTS */}
      <div style={{ position: 'fixed', bottom: '24px', left: '50%', transform: 'translateX(-50%)', zIndex: 999, display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'center' }}>
        {toasts.map(t => (
          <div key={t.id} style={{ background: t.type === 'ok' ? '#22C55E' : t.type === 'err' ? '#EF4444' : '#1C1C1C', color: '#fff', padding: '11px 22px', borderRadius: '9px', fontSize: '13px', fontWeight: '700', boxShadow: '0 4px 20px rgba(0,0,0,.4)', whiteSpace: 'nowrap' }}>
            {t.msg}
          </div>
        ))}
      </div>
    </div>
  );
}

export default DashboardVendeur;
